import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LayoutUtilsService, MessageType } from '../../../../../../core/_base/crud';
import { StringUtilsService } from '../../../../../../core/services/string-utils.service';
import { AppState } from '../../../../../../core/reducers';
import { BehaviorSubject, fromEvent, Observable } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { RelationshipCategoryService } from '../../../../../../core/lists/_services/relationship-category.service';
import { AuthService } from '../../../../../../core/auth/_services';
import { debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { QrveyService } from '../../../../../../core/lists/_services/qrvey.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'kt-page-group-edit',
  templateUrl: './page-group-edit.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageGroupEditComponent implements OnInit, OnDestroy {
  companyId: number;
  loadingSubject = new BehaviorSubject<boolean>(true);
  loading$: Observable<boolean>;
  pageGroupForm: FormGroup;
  hasFormErrors = false;
  submissionErrorObj: any;
  hasSubmissionErrors: boolean;
  subscriptions = [];
  // pages = [];
  allPages = [];
  optionPages = [];
  selectedPages = [];
  @ViewChild('pagess', { static: true }) pagess: ElementRef;

  constructor(
    public dialogRef: MatDialogRef<PageGroupEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private store: Store<AppState>,
    private authService: AuthService,
    private router: Router,
    private pageGroupFB: FormBuilder,
    private relationshipCategoryService: RelationshipCategoryService,
    private translate: TranslateService,
    private cdr: ChangeDetectorRef,
    public dialog: MatDialog,
    private layoutUtilsService: LayoutUtilsService,
    public stringUtils: StringUtilsService,
    private qrveyService: QrveyService,
  ) {}

  ngOnInit() {
    this.createForm();
    this.authService.getQRVEYApps(null, this.data.appId).subscribe((res) => {
      this.allPages = res.data.pages;
      this.optionPages = this.allPages;
    });

    const searchSubscription = fromEvent(this.pagess.nativeElement, 'keyup')
      .pipe(
        debounceTime(150),
        distinctUntilChanged(),
        tap(() => {
          this.pagesAutoComplete(this.pagess.nativeElement.value);
        }),
      )
      .subscribe();
    this.subscriptions.push(searchSubscription);
  }

  getTitle() {
    if (this.data.mode === 'CREATE') return 'New Page Group';
    return 'Update Page Group - ' + this.data._item.name;
  }

  ngOnDestroy() {
    this.cdr.detach();
    this.subscriptions.forEach((el) => {
      if (el.sub) {
        el.sub.unsubscribe();
      }
    });
  }

  createForm() {
    this.selectedPages = this.data._item?.pages ? this.data._item.pages : [];
    this.pageGroupForm = this.pageGroupFB.group({
      name: [this.data._item?.name ? this.data._item.name : null, Validators.required],
      pages: [this.data._item?.pages ? this.data._item.pages : null, Validators.required],
    });
  }

  onSubmit() {
    this.hasFormErrors = false;
    const controls = this.pageGroupForm.controls;
    if (this.pageGroupForm.invalid) {
      Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());
      this.hasFormErrors = true;
      return;
    }
    if (this.data.mode === 'CREATE') {
      this.addPageGroup(this.preparePageGroup());
      return;
    }
    this.updatePageGroup(this.preparePageGroup());
  }

  preparePageGroup(): any {
    const controls = this.pageGroupForm.controls;
    const pageGroup = {
      id: this.data._item && this.data._item.id ? this.data._item.id : null,
      name: controls.name.value,
      pages: controls.pages.value,
    };

    return pageGroup;
  }

  addPageGroup(_pageGroup) {
    this.qrveyService.createPageGroup(_pageGroup, this.data.appId).subscribe(() => {
      this.layoutUtilsService.showActionNotification(
        'Page Group Added Successfully',
        MessageType.Update,
        3000,
        false,
        false,
      );
      this.dialogRef.close();
    });
  }

  updatePageGroup(_pageGroup) {
    this.qrveyService.updatePageGroup(_pageGroup, this.data.appId).subscribe(() => {
      this.layoutUtilsService.showActionNotification(
        'Page Group updated Successfully',
        MessageType.Update,
        3000,
        false,
        false,
      );
      this.dialogRef.close();
    });
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.pageGroupForm.controls[controlName];
    if (!control) {
      return false;
    }
    return control.hasError(validationType) && (control.dirty || control.touched);
  }

  close() {
    this.dialogRef.close();
  }

  pageFn(event: any): string {
    return event ? event.name : '';
  }

  private pagesAutoComplete(term: string) {
    let _term = '' + term;
    _term = _term.trim();
    this.optionPages = this.allPages.filter((item) => item.name.includes(_term));
    this.cdr.detectChanges();
    return;
  }

  remove(p): void {
    const objWithIdIndex = this.selectedPages.findIndex((obj) => obj.id === p.id);
    this.selectedPages.splice(objWithIdIndex, 1);

    this.pageGroupForm.get('pages').setValue(this.selectedPages);
    this.cdr.detectChanges();
  }

  selected1(event: MatAutocompleteSelectedEvent): void {
    this.selectedPages.push(event.option.value);
    this.pagess.nativeElement.value = '';
    this.pageGroupForm.get('pages').setValue(this.selectedPages);
    this.cdr.detectChanges();
  }

  isSelected(p: any) {
    if (this.selectedPages?.indexOf(p) !== -1) return true;
    return false;
  }
}
